import { render, staticRenderFns } from "./ModalDetalhesOportunidade.vue?vue&type=template&id=03477649"
import script from "./ModalDetalhesOportunidade.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesOportunidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports